import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { usePageTitle } from "@/hooks/usePageTitle";
import { WorkforceFilterProvider } from "@/contexts/WorkforceFilterContext";
import { WorkforceActions } from "@/components/workforce/WorkforceActions";
import { WorkforceStats } from "@/components/workforce/WorkforceStats";
import { WorkforceFilterWrapper } from "@/components/workforce/WorkforceFilterWrapper";
import { WorkforceContent } from "@/components/workforce/WorkforceContent";
import { AddWorkforceModal } from "@/components/workforce/AddWorkforceModal";

const WorkforcePageContent = () => {
	const { t } = useTranslation();
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const [refreshKey, setRefreshKey] = useState(0);

	usePageTitle(t("workforce.pageTitle", "Workforce"));

	const handleRefresh = () => {
		setRefreshKey(prev => prev + 1);
	};

	return (
		<div className="w-full">
			<PageHeader
				title={t("workforce.header", "Workforce Management")}
				actions={
					<WorkforceActions onAddClick={() => setIsAddModalOpen(true)} />
				}
			/>

			<WorkforceStats />

			<WorkforceFilterWrapper />
			<WorkforceContent key={refreshKey} onRefresh={handleRefresh} />

			<AddWorkforceModal
				open={isAddModalOpen}
				onOpenChange={setIsAddModalOpen}
				onSuccess={handleRefresh}
			/>
		</div>
	);
};

export default function Workforce() {
	return (
		<WorkforceFilterProvider>
			<WorkforcePageContent />
		</WorkforceFilterProvider>
	);
}
